import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger, SheetDescription } from "@/components/ui/sheet";
import { Logo } from "@/components/brand/Logo";
import { CallButton, WhatsAppButton } from "@/components/common/ContactButtons";
import { NAV_LINKS } from "@/data/copy";
import { useSite } from "@/context/SiteContext";

export const MobileNav = () => {
  const [open, setOpen] = useState(false);
  const { settings } = useSite();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button type="button" data-testid="mobile-menu-btn" aria-label="Open menu" className="flex h-11 w-11 items-center justify-center rounded-full text-brand-ink hover:bg-brand-tint xl:hidden">
          <Menu className="h-6 w-6" aria-hidden="true" />
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="flex w-[88vw] max-w-sm flex-col p-0" data-testid="mobile-menu">
        <div className="border-b border-slate-100 px-6 py-5">
          <SheetTitle><Logo className="h-9 w-auto" /></SheetTitle>
          <SheetDescription className="sr-only">Site navigation</SheetDescription>
        </div>
        <nav aria-label="Mobile" className="flex-1 overflow-y-auto px-3 py-4">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) => `block rounded-xl px-4 py-3 text-lg font-medium ${isActive ? "bg-brand-tint2 text-brand-blue" : "text-brand-ink hover:bg-brand-tint"}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="space-y-3 border-t border-slate-100 p-5">
          <p className="text-sm font-semibold text-brand-ink">Book an appointment</p>
          <CallButton label={`Call ${settings.phone_display}`} className="w-full" testid="mobile-menu-call-btn" />
          <WhatsAppButton label="Book on WhatsApp" className="w-full" testid="mobile-menu-whatsapp-btn" />
        </div>
      </SheetContent>
    </Sheet>
  );
};
